import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ESalutation } from 'projects/shared/lib/enum/salutation/salutation.enum';

/**
 * Pipe regarding the displaying of salutation options.
 * requires an import in the decorator.
 * usage only inside the html template. NO TS CODE.
 * for ts code useage @see ESalutationToOptionStringService
 */
@Pipe({
  name: 'eSalutationToOptionString',
  standalone: true
})
export class ESalutationToOptionStringPipe implements PipeTransform {

  public transform(salutation: string | undefined): string {
    return ESalutationToOptionStringService.transform(salutation);
  }

}

/**
 * Pipe regarding the displaying of salutation options.
 * no import required.
 * no instance required.
 * usage only inside the ts code. NO HTML TEMPLATE.
 * for html template usage @see ESalutationToOptionStringPipe
 */
@Injectable({
  providedIn: 'root'
})
export class ESalutationToOptionStringService {

  public static transform(salutation: string | undefined): string {

    switch (salutation) {

      case ESalutation[ESalutation.Herr].toString(): {
        return $localize`:@@ESalutationToOptionStringPipeMister:Mister`;
      }

      case ESalutation.Herr.toString(): {
        return $localize`:@@ESalutationToOptionStringPipeMister:Mister`;
      }

      case ESalutation.Frau.toString(): {
        return $localize`:@@ESalutationToOptionStringPipeMadam:Madam`;
      }

      case ESalutation[ESalutation.Frau].toString(): {
        return $localize`:@@ESalutationToOptionStringPipeMadam:Madam`;
      }

      default: {
        return $localize`:@@ESalutationToOptionStringPipeUnset:`;
      }

    }
  }

}
